import Banner from "../Banner/Banner";
import Products from "../Products/Products";
import "../Products/Products.css";
const Home = () => {
  return (
    <>
      <Banner />

      <Products />
    </>
  );
};

export default Home;
